module.exports = __webpack_public_path__ + "img/243.e0b6da42.jpg";